import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Duration_Type_Enum, Preservation_Method_Enum } from '@kheops/graphql';
import CalendarImage from '../../assets/images/3d-icons/calendar.png';
import FrozenImage from '../../assets/images/frozen.png';
import RefrigeratedImage from '../../assets/images/refrigerated.png';
import InfoBox from '../../common/components/InfoBox';

export interface PackagingPreservationInfoProps {
  preservationMethod?: Preservation_Method_Enum | null;
  shelfLifeDurationType?: Duration_Type_Enum | null;
  shelfLifeDuration?: number | null;
}

const PreservationMethodDisplayInfoMap = {
  [Preservation_Method_Enum.Frozen]: {
    icon: FrozenImage,
    label: 'products:preservation_method_frozen',
  },
  [Preservation_Method_Enum.Refrigerated]: {
    icon: RefrigeratedImage,
    label: 'products:preservation_method_refrigerated',
  },
};

export default function PackagingPreservationInfo({ preservationMethod, shelfLifeDurationType, shelfLifeDuration }: PackagingPreservationInfoProps): React.JSX.Element {
  const { t } = useTranslation(['products']);

  return (
    <>
      {(preservationMethod && preservationMethod !== Preservation_Method_Enum.None) && (
        <InfoBox>
          <img src={PreservationMethodDisplayInfoMap[preservationMethod].icon} height="24" width="24" alt="" />
          <Typography variant="titleSmall">
            {t(PreservationMethodDisplayInfoMap[preservationMethod].label)}
          </Typography>
        </InfoBox>
      )}
      {shelfLifeDurationType === Duration_Type_Enum.Days && shelfLifeDuration! <= 31 && (
        <InfoBox>
          <img src={CalendarImage} height="24" width="24" alt="" />
          <Typography variant="titleSmall" sx={{ whiteSpace: 'nowrap' }}>
            {t('products:short_shelf_life_days', { count: shelfLifeDuration! })}
          </Typography>
        </InfoBox>
      )}
    </>
  );
}
